import styled from 'styled-components';
import {dFlexColumn, dFlexCenter} from '../../../globalVariables/GlobalFlex';

export const container = styled.div`
    ${dFlexColumn};
    height: 100%;
    min-height: 0;
`;

export const stub = styled.div`
    flex: none;
    width: 100%;
    ${dFlexCenter};
    flex-wrap: wrap;
    gap: var(--space-md);
    padding: var(--space-xl) var(--space-md);
    padding-top: 0px;
    position: relative;
`;

